import { listenForChildRequests } from './consentChildListener';

listenForChildRequests(() => window.__racemapUserConsent ?? null);
